import type * as React from 'react';
import { get } from '@Domain/Api';
import workflowRunStatusFiltersFetched, {
	type WorkflowRunStatusFiltersFetchedAction,
	type WorkflowRunStatusFiltersFetchedPayload,
} from '@Application/WorkflowRuns/WorkflowRunStatusFilters/Actions/workflowRunStatusFiltersFetched';
import workflowRunStatusFiltersFetchFailed, {
	type WorkflowRunStatusFiltersFetchFailedAction,
} from '@Application/WorkflowRuns/WorkflowRunStatusFilters/Actions/workflowRunStatusFiltersFetchFailed';
import type FetchWorkflowRunStatusFilters from '@Application/WorkflowRuns/WorkflowRunStatusFilters/Queries/FetchWorkflowRunStatusFilters';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = WorkflowRunStatusFiltersFetchedAction | WorkflowRunStatusFiltersFetchFailedAction;

/** A referential list of status filters: no tenant, no parameter. */
export default (_query: FetchWorkflowRunStatusFilters) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<WorkflowRunStatusFiltersFetchedPayload>(
				`${parameters.api.host}/api/enums/workflow-run-status-filters`,
			);

			const action = workflowRunStatusFiltersFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunStatusFiltersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
